import React from 'react'
import { Link } from 'react-router-dom'
import view from './assets/view2.jpg'
import { Hme } from './home.styled'
import Button from 'react-bootstrap/Button'
import Carousel from 'react-bootstrap/Carousel'
import MenuSvg from './assets/menu_svg'
import DrinkSvg from './assets/drink_svg'
import EventSvg from './assets/event_svg'
import dine1 from './assets/beehive/dinning1.jpg'
import dine2 from './assets/beehive/view1.jpg'
import dine3 from './assets/beehive/view3.jpg'
import wings from './assets/beehive/wings2.jpg'
import burger from './assets/beehive/burger.jpg'
import tacos from './assets/beehive/tacos.jpg'
import dj1 from './assets/beehive/dj1.jpg'
import dj2 from './assets/beehive/dj2.jpg'
import dj3 from './assets/beehive/dj5.jpg'
import logo from './assets/custom.webp'
import whatsapp from './assets/beehive/whatsapp.svg'




export default function Home() {
  
  document.querySelector('title').innerText = 'Beehive Cafe'
  React.useEffect(() => {
    const loader = document.querySelector('.loading')
    loader.style.display = 'none'
  
    return () => {
      loader.style.display = 'block'
    }
  }, [])
  
  return (
    <Hme>
    <div className='intro'>
      <img height={'500px'} width='100%' src={view} alt="" />
      <section>
      <div className='text1'><h1>Welcome to the Cooolest Spot in Mabopane</h1></div>
      <div className='text2'><h1>Food, Drinks, Muscic, Daytime fun and a relaxing atmosphere</h1></div>
      <div className="actions">
         <Button as={Link} to='/menu' variant='primary'><DrinkSvg/> {' '} <i> Drinks</i></Button>
         <Button as={Link} to='/events' variant='danger'><EventSvg/> {' '} <i>Upcoming Events</i></Button>
      </div>
      </section>
    </div>
    <section className='showcase'>
      <div className="sitting">
        <Carousel className='carousel' fade interval={1500}>
          <Carousel.Item>
            <img height={'350px'} src={dine1} alt="" />
            <Carousel.Caption>
             <h1>5 Star sitting arrangements</h1> 
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img height={'350px'} src={dine2} alt="" />
            <Carousel.Caption>
             <h1>5 Star sitting arrangements</h1> 
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img height={'350px'} src={dine3} alt="" />
            <Carousel.Caption>
             <h1>5 Star sitting arrangements</h1> 
            </Carousel.Caption>
          </Carousel.Item>
      </Carousel>
      <div className="text">
        <h1> The Cafe is designed follwing  <br />
        the Color Psychology <br /> to bring GOOD VIBES and <br /> SMILES in our customers</h1>
      </div>
      </div>
    </section>
    <section className='showcase2'>
      <div className="cuisine">
      <div className="text">
        <h1> The Food is prepared by a<br />
        Qualified Chef bringing <br /> international experience <br /> But keeping the KASI VIBE </h1>
        <Button variant='success' as={Link} to='/menu'><MenuSvg/> {' '} <i> See Menu </i></Button>
      </div>
        <Carousel className='carousel' fade interval={1500}>
          <Carousel.Item>
            <img height={'350px'} src={wings} alt="" />
            <Carousel.Caption>
             <h1>5 Star Food Cuisine </h1> 
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img height={'350px'} src={burger} alt="" />
            <Carousel.Caption>
             <h1>5 Star Food Cuisine </h1> 
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img height={'350px'} src={tacos} alt="" />
            <Carousel.Caption>
             <h1>5 Star Food Cuisine </h1> 
            </Carousel.Caption>
          </Carousel.Item>
      </Carousel>
      
      </div>
    </section>
    <section className='showcase3'>
      <div className="weekends">
      
        <Carousel className='carousel' fade interval={1500}>
          <Carousel.Item>
            <img height={'350px'} src={dj1} alt="" />
            <Carousel.Caption>
             <h1>Weekends With A Celebration </h1> 
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img height={'350px'} src={dj2} alt="" />
            <Carousel.Caption>
             <h1>Weekends With A Celebration </h1> 
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img height={'350px'} src={dj3} alt="" />
            <Carousel.Caption>
             <h1>Weekends With A Celebration </h1> 
            </Carousel.Caption>
          </Carousel.Item>
      </Carousel>
      <div className="text">
        <h1> Every Weekend the DJ Plays <br />
        House or RNB Music <br /> To blow off some steam after <br /> A long week of work and
        Life<br />  Challenges for our Customers</h1>
      </div>
      </div>
    </section>
    <div className="conc">
    <div>
    <div className='hr-h'>
    <h2>Business Hours</h2>
    </div>
    <div className="hours-wrap">
      <div className="hours">
        <div><div className='day'>Monday</div><div>11 : 00 - 22 : 00</div></div>
        <div><div className='day'>Tuesday</div><div>11 : 00 - 22 : 00</div></div>
        <div><div className='day'>Wednesday</div><div>11 : 00 - 22 : 00</div></div>
        <div><div className='day'>Thusday</div><div>11 : 00 - 22 : 00</div></div>
        <div><div className='day'>Friday</div><div>11 : 00 - 22 : 00</div></div>
        <div><div className='day'>Saturday</div><div>11 : 00 - 22 : 00</div></div>
        <div><div className='day'>Sunday</div><div>11 : 00 - 22 : 00</div></div>
      </div>
    </div>
    </div>
    <div className="about">
      <img src={logo} alt="" />
      <h2>BeeHive Cafe ...</h2>
      <a style={{fontWeight: '500'}} rel='noreferrer' target="_blank" href='https://wa.me/+27767707300'><img width={'40px'} src={whatsapp} alt="" /> Whatsapp Us</a>
    </div>
    </div>
    </Hme>
  )
}
